import React, { useEffect } from 'react'


/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Grid, Typography } from '@mui/material';
import _ from "lodash";


/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const ClusterPieChart = ({ keyId, year, title, dataCluster, dataPie }) => {

    useEffect(() => {

        let ElementId = "chart-clusterticket-" + keyId;
        let chart = am4core.create(ElementId, am4charts.XYChart)
        chart.colors.step = 2;

        chart.legend = new am4charts.Legend()
        chart.legend.maxHeight = 195;
        chart.legend.scrollable = true;
        chart.legend.fontSize = 12; // Set the font size here

        let xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
        xAxis.dataFields.category = 'sMonth'
        xAxis.renderer.cellStartLocation = 0.1
        xAxis.renderer.cellEndLocation = 0.9
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 20;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "จำนวน(คน)";
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        valueAxis.numberFormatter = new am4core.NumberFormatter();
        valueAxis.numberFormatter.numberFormat = "#"; 
        valueAxis.adjustLabelPrecision = false;

        let letRenderBar = dataCluster[0].lstTicketSoldTypeValue || [];
        letRenderBar.forEach(element => {
            createSeries(element.sField, element.sName, true);
        });

        let cloneData = _.cloneDeep(dataCluster) || [];
        cloneData.forEach(element => {
            (element.lstTicketSoldTypeValue || []).forEach(subElement => {
                element[subElement.sField] = subElement.sValue;
            })
        });
        chart.data = cloneData;
        createSeries('nFree', 'ฟรี', false,"#f3425f");


        function createSeries(value, name, stacked, color = null) {
            let series = chart.series.push(new am4charts.ColumnSeries())
            series.dataFields.valueY = value
            series.dataFields.categoryX = 'sMonth'
            series.name = name
            series.columns.template.tooltipText = name + ": [bold]{valueY}[/]";
            series.stacked = stacked;
            if(color)
            {
                series.columns.template.stroke = am4core.color(color); 
                series.columns.template.fill = am4core.color(color);
            }

            let labelBullet = series.bullets.push(new am4charts.LabelBullet())
            labelBullet.label.fontSize = 10;
            labelBullet.label.fontWeight = "normal";
            labelBullet.label.hideOversized = true;
            labelBullet.interactionsEnabled = false
            labelBullet.dy = 15;
            labelBullet.label.text = '{valueY}'
            labelBullet.label.fill = am4core.color('#ffffff')

            return series;
        }

        return () => {
            chart.dispose();
        };
    }, [dataCluster, keyId, title])


    useEffect(() => {
        let chart = null;
        let hasValue = dataPie.findIndex(f => f.sValue !== "0") !== -1;

        if (hasValue) {
            // Create chart instance
            chart = am4core.create("chart-pieticket-" + keyId, am4charts.PieChart);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
            chart.alignLabels = true;

            // Set data
            let selected;
            let types = dataPie;

            chart.colors.step = 2;

            chart.data = generateChartData();

            chart.radius = am4core.percent(45);

            let pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "sValue";
            pieSeries.dataFields.category = "sField";
            pieSeries.labels.template.text = "{sName}: {value.percent.formatNumber('#.00')}%";
            pieSeries.slices.template.tooltipText = "{sName}: {value} ({value.percent.formatNumber('#.00')}%)";
            pieSeries.labels.template.fontSize = 10;
            pieSeries.labels.template.maxWidth = 100;
            pieSeries.labels.template.wrap = true;
            pieSeries.slices.template.propertyFields.fill = "sColor";
            pieSeries.slices.template.propertyFields.isActive = "pulled";
            pieSeries.slices.template.strokeWidth = 0;
            // pieSeries.alignLabels = false;



            pieSeries.slices.template.events.on("hit", function (event) {
                if (event.target.dataItem.dataContext.id !== undefined) {
                    selected = event.target.dataItem.dataContext.id;
                } else {
                    selected = undefined;
                }
                chart.data = generateChartData();
            });

            function generateChartData() {
                let chartData = [];
                for (var i = 0; i < types.length; i++) {
                    if (i === selected) {
                        for (var x = 0; x < types[i].lstTicketType.length; x++) {
                            chartData.push({
                                sField: types[i].lstTicketType[x].sField,
                                sValue: types[i].lstTicketType[x].sValue,
                                sName: types[i].lstTicketType[x].sName,
                                sColor: types[i].sColor,
                                pulled: true
                            });
                        }
                    } else {
                        chartData.push({
                            sField: types[i].sField,
                            sValue: types[i].sValue,
                            sColor: types[i].sColor,
                            sName: types[i].sName,
                            id: i
                        });
                    }
                }
                return chartData;
            }


        }
        else {
            chart = am4core.create("chart-pieticket-" + keyId, am4charts.PieChart);
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            chart.data = [{
                "sField": "Dummy",
                "disabled": true,
                "sValue": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            },
            {
                "sField": "คิดเงิน",
                "disabled": false,
                "sValue": 0,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": "คิดเงิน"
            },
            {
                "sField": "ฟรี",
                "disabled": false,
                "sValue": 0,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": "ฟรี"
            }
            ];

            chart.radius = am4core.percent(45);


            let series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "sValue";
            series.dataFields.category = "sField";
            series.dataFields.hiddenInLegend = "disabled";
            series.labels.template.fontSize = 10;
            series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            series.tooltip.label.wrap = true;
            series.tooltip.label.width = 300;
            series.labels.template.maxWidth = 180;
            series.labels.template.wrap = true;


            /* Set tup slice appearance */
            let slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";

            /* This creates initial animation */
            series.hiddenState.properties.opacity = 1;
            series.hiddenState.properties.endAngle = -90;
            series.hiddenState.properties.startAngle = -90;
        }



        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };
    }, [dataPie, keyId, title])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography textAlign={"center"} fontWeight={500} sx={{ fontSize: '1.5rem !important' }}>จำนวนผู้เข้าชม {title}</Typography>
            </Grid>
            <Grid item xs={12} md={8}>
                <div id={"chart-clusterticket-" + keyId} style={{ width: "100%", height: "500px" }}></div>
            </Grid>
            <Grid item xs={12} md={4}>
                <div id={"chart-pieticket-" + keyId} style={{ width: "100%", height: "450px" }}></div>
            </Grid>

        </Grid>
    )
}

export default ClusterPieChart